import { apiClient } from "shared/utils";

export const postComeBackMailingReprocessExistingSessions = async (shopId: number) => {
  const { data } = await apiClient.post<void>(`/${shopId}/triggers/come-back-mailing/reprocess`);

  return data;
};
